import { type UseQueryResult, useQuery } from 'react-query';

import {
  TradeOrderSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_TradeOrder_OrderView,
} from '../../services/wealthlane-award-settlement-services';

const useGetTradeOrderTransactionByIdFromVendor = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  transactionId: string,
  companyId?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_TradeOrder_OrderView | undefined,
  unknown
> => {
  const tradeOrderTransactionById = useQuery(
    ['tradeOrderTransactionByIdFromVendor', transactionId, companyId],
    async () => {
      if (transactionId) {
        return await handleRequest(
          TradeOrderSharedService.getApiAwardSettlementApiAppTradeOrderTradeOrderByTransactionIdFromVendor(
            transactionId,
            companyId
          )
        );
      }
    },
    {
      enabled: !!transactionId,
    }
  );

  return tradeOrderTransactionById;
};

export default useGetTradeOrderTransactionByIdFromVendor;
